
var dropdownLess = {};
import genaration from '../../utils/classname';
export var dropdownClass = genaration(dropdownLess, 'dropdown');